export default {
  SolutionFaceIn: [{
    title: '民生政务',
    content: '为响应国家提出让群众企业办事“网购”一样方便，各委办局纷纷开展线上业务办理服务， 用户打开各委办局的公众号或小程序，调用FaceIn人脸核身服务进行实名注册 ，验证通过后可以预约办理各项业务。',
    imgUrl: require('../img/scene/pic_yy1.jpg')
  }, {
    title: '金融行业',
    content: '为方便用户办理业务，许多银行提供远程开户服务，在各大银行的公众号或 APP 中，点击远程开户服务，填写身份信息，调用FaceIn人脸核身服务进行实名认证，验证通过即可申请账户。',
    imgUrl: require('../img/scene/pic_yy2.jpg')
  }, {
    title: '通信运营商',
    content: '根据实名制要求，用户办理运营商业务时必须实名，运营商为方便用户办理业务开通网上业务，用户在运营商的 APP 或者公众号上，使用FaceIn人脸核身提供的服务进行实名认证，认证通过后，可以在网上自助办理手机业务。',
    imgUrl: require('../img/scene/pic_yy3.jpg')
  }, {
    title: '场所实名登记',
    content: '根据实名制要求，出入网吧需要进行身份登记，网吧在前台系统中调用腾讯云慧眼人脸核身服务，用户上网时，需要在前台进行实名认证，认证通过登记身份后，即可进行网吧上网。',
    imgUrl: require('../img/scene/pic_yy4.jpg')
  }],
  SolutionForgery: [{
    title: '金融开户',
    content: '在金融开户场景下，证件鉴伪解决方案大大降低因证件造假而造成的风险，有效提高金融机构的业务安全保障，降低业务风险。',
    imgUrl: require('../img/scene/application_ID_antifake.jpg')
  }],
  SolutionAuditing: [{
    imgUrl: require('../img/scene/you_safe_pic4.1.jpg'),
    content: '对于存在大量用户UGC内容的社交、电商等平台充斥着大量的不良内容，让平台面临监管风险。接入优图内容安全解决方案后，可以全方面识别图像内容、快速定位问题，降低平台违规风险。',
    title: '社交、电商等平台内容安全'
  }, {
    imgUrl: require('../img/scene/you_safe_pic4.2.jpg'),
    content: '直播、短视频等场景中使用优图内容安全解决方案，可以智能识别主播的各类行为，降低直播平台管理成本和违规风险。',
    title: '直播、短视频平台内容安全'
  }, {
    imgUrl: require('../img/scene/you_safe_pic4.3.jpg'),
    content: '广电媒体行业需要保障自身广告、新闻、影视等作品的内容安全，传统的人工效率低下、漏检率和成本极高，接入优图内容安全解决方案后实现智能、自动、精准、高速识别视频、图片、文本中的不适宜内容，进一步提高识别效率，提升新媒体的网络质量。',
    title: '广电媒体行业内容安全'
  }],
  SolutionBroadcast: [{
    imgUrl: require('../img/scene/you_video_pic4.1.jpg'),
    content: '直播类产品接入视频直播解决方案后，主播既可以自己选择美容美妆等特效，用户也可以在主播直播时以送礼物的形式送出动态贴纸、全景粒子等各类特效，增强用户和主播之间的互动性。',
    title: '直播类产品'
  }, {
    imgUrl: require('../img/scene/you_video_pic4.2.jpg'),
    content: '短视频拍摄类产品接入视频直播解决方案后，可以实现拍摄视频时在人脸上叠加具有动态效果的贴图和道具，也可对背景做处理，免去视频拍摄后的复杂处理，降低了不少短视频拍摄的生产成本。',
    title: '短视频拍摄类产品'
  }],
  SolutionInvoice: [{
    imgUrl: require('../img/softbox/cwpj_pic3.1.jpg'),
    content: '在财务报销环节将发票信息结构化识别后自动录入系统，提升财务人员工作效率，节省90%的报销工作量。',
    title: '财务报销',
    noBg: true
  }, {
    imgUrl: require('../img/softbox/cwpj_pic3.2.jpg'),
    content: '提取发票中发票号码、发票代码、开票日期等信息后，可以接入税务机关的查验平台，查询发票真伪。',
    title: '发票验真',
    noBg: true
  }, {
    imgUrl: require('../img/softbox/cwpj_pic3.3.jpg'),
    content: '在理财记账、日程管理等应用中，通过识别票据信息实现个人账单、日程的记录，帮助用户合理规划生活，养成良好的生活习惯。',
    title: '个人账单记录',
    noBg: true
  }],
  SolutionEducation: [{
    imgUrl: require('../img/softbox/edu_pic_01.jpg'),
    content: '借助中文文本识别能力与数学公式识别能力，识别试题/作业文本内容，为后续的搜题功能建设提供鲁棒输入。',
    title: '搜题基础能力建设',
    noBg: true
  }, {
    imgUrl: require('../img/softbox/edu_pic_02.jpg'),
    content: '借助中文文本识别能力与数学公式识别能力，识别试题/作业文本内容，并进一步基于试题固有结构信息进行重构，将纸质试题数字化，便于教育者录入教学信息。',
    title: '试题内容自动化入库',
    noBg: true
  }, {
    imgUrl: require('../img/softbox/edu_pic_03.jpg'),
    content: '借助中文文本识别能力与数学公式识别能力，为用户提供速算题目的自动识别和判分服务，代替学生家长和老师的手工劳动，轻松完成学生作业检查工作。目前已支持14种小学主要题型，包括加减乘除四则运算、分数四则运算、单位换算、竖式四则、脱式计算、解方程等。',
    title: '拍照批改小学数学题',
    noBg: true
  }, {
    imgUrl: require('../img/softbox/edu_pic_04.jpg'),
    content: '借助高精度英文文本识别能力，实现全学力范围的英文作文内容识别，可为后续的作文批改提供鲁棒输入。',
    title: '全学力英文作文批改',
    noBg: true
  }],
  SolutionInsurance: [{
    imgUrl: require('../img/softbox/znbx_pic3.1.jpg'),
    content: '在核保环节，实现对投保人体检报告的结构化识别及系统录入，减轻保险公司核保处理人员的工作负担，提升工作效率。',
    title: '保险核保',
    noBg: true
  }, {
    imgUrl: require('../img/softbox/znbx_pic3.2.jpg'),
    content: '采用成熟、先进的人工智能相关技术，满足保险公司对理赔单据的文字识别和结构化提取需求，助力理赔业务实现从传统理赔到智能理赔的转型，提高理赔效率，降低理赔成本，同时确保风险可控。',
    title: '保险理赔',
    noBg: true
  }],
  SolutionSDKProduction: [{
    imgUrl: require('../img/softbox/sdk_pic3.1.jpg'),
    content: '可组合接入多种SDK能力丰富自身的产品功能，适用于营销推广、互动娱乐等场景，满足不同的用户体验。',
    title: '在线营销互动',
    noBg: true
  }, {
    imgUrl: require('../img/softbox/sdk_pic3.2.jpg'),
    content: '丰富互动工具产品应用，可满足于实时视频流，图片等不同应用场景的处理需求，丰富开发者的产品体验。',
    title: '直播/短视频、相机工具',
    noBg: true
  }],
  SolutionVideoUnderstand: [{
    imgUrl: require('../img/videounderstand/splj_pic4.1.jpg'),
    content: '通过视频内容分析技术，可自动抽取视频内容标签，有效解决新视频推荐问题，实现个性化推荐，助力目标应用提升DAU、用户浏览时长等。',
    title: '视频平台内容推荐',
    noBg: true
  }, {
    imgUrl: require('../img/videounderstand/splj_pic4.2.jpg'),
    content: '针对海量视频内容可智能生成封面图，进行GIF动图提取，便于用户快速处理视频内容，优化产品体验，提高素材生成效率。',
    title: '智能视频处理',
    noBg: true
  }],
  SolutionFaceInFW: [{
    imgUrl: require('../img/faceinfw/antifake_pic_yy1.jpg'),
    content: '进一步加强虚假人脸的鉴别能力，提升线上人脸核身、人脸验证等场景的安全性，避免业务损失。',
    title: '线上人脸验证安全性升级',
    noBg: true
  }, {
    imgUrl: require('../img/faceinfw/antifake_pic_yy2.jpg'),
    content: '助力媒体平台对虚假视频及图像内容进行高效甄别，解决虚假信息在社交平台上广泛传播现象，打击网络不实信息传播，还原事实真相。',
    title: '多媒体平台内容甄别',
    noBg: true
  }, {
    imgUrl: require('../img/faceinfw/antifake_pic_yy3.jpg'),
    content: '协助相关部门对案件调查、法庭辩论中涉及的视频、图像等证据材料进行真实性鉴定，提供专业准确的鉴定结果，降低鉴别成本。',
    title: '影像物证真实性检验',
    noBg: true
  }, {
    imgUrl: require('../img/faceinfw/antifake_pic_yy4.jpg'),
    content: '支持用户自行创建工具组件，用于判断所上传视频或图片材料中的人脸是否被修改，为用户提供自定义高效验证工具，保护用户权益。',
    title: '用户影像资料验证',
    noBg: true
  }],
  SolutionTim: [{
    imgUrl: require('../img/scene/tim_01.png'),
    content: '应用于编辑记者等人员进行素材检索查询场景，支持通过标签在海量素材库中快速定位相关素材，并支持定位到具体视频中标签出现的时间段，方便进行素材级的内容定位和资源再利用。',
    title: '检索查询',
    noBg: true
  }, {
    imgUrl: require('../img/scene/tim_02.png'),
    content: '根据素材的事件标签和人物标签，可实现热点话题、热门人物的专题内容板块的快速搭建，降低专题活动的素材汇总成本，提高内容运营的效率和质量。',
    title: '内容运营',
    noBg: true
  }, {
    imgUrl: require('../img/scene/tim_03.png'),
    content: '结合智能推荐技术，实现内容与用户的精准匹配，根据用户关注、用户观看记录等用户行为实现用户个性化推荐，打造“千人千面”的用户运营系统。',
    title: '用户运营',
    noBg: true
  }, {
    imgUrl: require('../img/scene/tim_04.png'),
    content: '针对视频采集、传输、后期过程以及编解码过程中出现的不同类型的质量问题进行检测，通过AI手段，快速定位并过滤低质内容。',
    title: '视频质检',
    noBg: true
  }]
};



// WEBPACK FOOTER //
// ./src/components/open/panels/solution/panels/data/ApplicationConstant.js